import { Dialog } from '@mui/material'
import { ReactNode, useContext } from 'react'
import { Overlay } from 'react-overlays'

import { AppContext } from '../../providers/AppProvider/AppProvider'
import { SlideUpDialogTransition } from '../SharedUI/SlideUpDialogTransition'
import { OverlayContainer } from './ChatBoxTools'

export const ChatUIWrapper = ({
  dialogOpen,
  setDialogOpen,
  children,
  containerRef,
  anchorEl
}: {
  dialogOpen: boolean
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
  containerRef: React.RefObject<HTMLDivElement>
  anchorEl: HTMLElement | null
  children: ReactNode
}) => {
  const { overTabletBreakpoint } = useContext(AppContext)

  return (
    <>
      {overTabletBreakpoint ? (
        <Overlay
          show={dialogOpen}
          rootClose
          offset={[0, 10]}
          onHide={() => {}}
          placement="right-start"
          container={containerRef}
          target={anchorEl}>
          {({ props }) => (
            <OverlayContainer {...props}>{children}</OverlayContainer>
          )}
        </Overlay>
      ) : (
        <Dialog
          fullScreen
          open={dialogOpen}
          onClose={() => {
            setDialogOpen(false)
          }}
          TransitionComponent={SlideUpDialogTransition}
          keepMounted>
          {children}
        </Dialog>
      )}
    </>
  )
}
